import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

export default createMuiTheme({
    palette: {
        primary: {
            main: '#edce86',
        },
        secondary: {
            main: '#6b747c',
        },
        type: 'dark',
    },
    typography: {
        fontFamily: 'Open Sans',
        h1: {
            fontWeight: '800',
            fontSize: '3.5rem',
            color: 'var(--white)',
        },
        h5: {
            color: 'var(--white)',
            fontWeight: '700',
            fontSize: '1.3rem',
        },
        h6: {
            fontWeight: '700',
            fontSize: '1.1rem',
        },
    },
    overrides: {
        MuiButton: {
            contained: {
                background: 'var(--gold-gradient)',
                fontWeight: '700',
                fontSize: '1.1rem',
                textTransform: 'none',
            },
        },
        MuiIconButton: {
            root: {
                color: 'var(--gold)',
            },
        },
        MuiOutlinedInput: {
            // can't change hover color fuck
            root: {
                color: 'var(--white)',
            },
            notchedOutline: {
                border: '2px solid var(--grey)',
                borderRadius: '7px',
            },
        },
        MuiInput: {
            root: {
                color: 'var(--white)',
            },
            underline: {
                '&:before': {
                    borderBottom: '3px solid var(--grey)',
                },
            },
        },
        MuiInputLabel: {
            outlined: {
                color: 'var(--grey)',
                fontWeight: '600',
            },
            root: {
                color: 'var(--grey)',
                fontWeight: '600',
            },
        },
        MuiPaginationItem: {
            root: {
                color: 'var(--grey)',
                fontWeight: '700',
            },
        },
        MuiSlider: {
            root: {
                color: 'var(--gold)',
                '& span': {
                    ' & span': {
                        ' & span': {
                            ' & span': {
                                color: 'var(--side-color)',
                                fontWeight: '700',
                                textAlign: 'center',
                                lineHeight: '.6rem',
                            },
                        },
                    },
                },
            },
            markLabel: {
                color: 'var(--grey)',
                fontWeight: '600',
            },
            markLabelActive: {
                color: 'var(--white)',
            },
        },
        MuiCard: {
            root: {
                backgroundColor: 'var(--side-color)',
            },
        },
        MuiAlert: {
            message: {
                fontWeight: '600',
            },
        },
    },
});
